import { COLORS } from "../../utils/js/constants";

export default function userItemStyle() {
  return {
    card: {
      display: 'flex',
      background: COLORS.grey,
      alignItems: 'center',
      margin: '5px 0',
      border: 'solid #a0a0a0 1px',
      padding: 5,
      color: 'white'
    },
    cover: {
      minHeight: 110,
      width: 180,
      borderRadius: '5px',
      flex: 1
    },
    content: {
      padding: 0,
      margin: 0,
      marginLeft: 15,
      flex: 6
    },
    list: {
      display: 'flex',
      flexDirection: "column",
      flexWrap: 'wrap',
      padding: 0
    },
    listItem: {
      display: "flex",
      alignItems: "center",
      width: '50%',
      margin: 0,
      padding: 0,
      ['& span']: {
        fontWeight: 'bold',
        fontSize: '.8rem'
      },
      ['& p']: {
        fontSize: '.8rem',
        color: 'white',
        marginLeft: 5
      }
    },
    actions: {
      flex: 1
    },
    button: {
      width: 150,
      height: 25,
      marginTop: 5,
      borderRadius: 10,
      ['& span']: {
        fontSize: '0.65rem',
      },
      ['& span svg']: {
        fontSize: '12px !important'
      },
    },
    redBtn: {
      background: COLORS.danger,
      fontWeight: 600,
      color: COLORS.dark
    },
    yellowBtn: {
      background: COLORS.primary,
      fontWeight: 600,
      color: COLORS.dark
    }
  }
}
